import React from "react";
import styled from "styled-components";
import Button from "../../buttons/Button";
import {
    MELOGY_BLACK,
    MELOGY_WHITE,
} from "../../../style/colors";
import { findFarthestColor } from '../../../util/StyleSettingsUtil'
import { 
    getIcon, 
    getStyleColor 
} from "../../../util/StyleSettingsUtil"

const ButtonsBackground = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const GroupButtonsContainer = styled.div`
    margin-top: 8px;
    margin-bottom: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const GroupSelection = ({ selectedStyle, handleSelectGroup }) => {
    const buttonColor = findFarthestColor(getStyleColor(selectedStyle));
    const color = buttonColor === "white" ? MELOGY_WHITE : MELOGY_BLACK;
    const groupedStyleSettings = selectedStyle.reduce((acc, setting) => {
        const group = setting.group || "Misc.";
        if (!acc[group]) acc[group] = [];
        acc[group].push(setting);
        return acc;
    }, {});

    return (
        <ButtonsBackground>
            <GroupButtonsContainer>
                {Object.keys(groupedStyleSettings)
                    .filter((groupName) => groupName !== "Misc.") // Filter out "Misc." groups
                    .map((groupName) => (
                        <Button
                            key={groupName}
                            text={groupName}
                            height="32px"
                            width="100%"
                            justifyContent="flex-start"
                            buttonColor={buttonColor}
                            borderBottom="0"
                            onClick={() => handleSelectGroup(groupName)}
                            icon={getIcon(groupName, color)}
                        />
                    ))}
            </GroupButtonsContainer>
        </ButtonsBackground>
    );
};

export default GroupSelection;
